<template>
  <Delete
    resource="cost-allocators"
    dispatch="projectAccountingStore/costAllocatorStore/delete"
    :routing="from || 'cost-centres'"
    :id="id"
    :params="{ project_id: $route.params.project_id }"
  ></Delete>
</template>

<script>
import Delete from "../../../common/tabs/Delete";
export default {
  name: "DeleteCostAllocator",
  data: () => ({
    from: ""
  }),
  props: ["id"],
  components: { Delete },
  mounted() {
    this.from = this.$store.getters["historyStore/getRouterBefore"];
  }
};
</script>

<style scoped></style>
